import getBrowserFingerprint from 'get-browser-fingerprint';
/** Same key as `useDeviceId` when using StorageProvider + localStorage */
const STORAGE_KEY = 'device-id';
function readStoredId() {
    try {
        if (typeof window === 'undefined') {
            return null;
        }
        const value = window.localStorage.getItem(STORAGE_KEY);
        return value && value.length > 0 ? value : null;
    }
    catch (_a) {
        return null;
    }
}
function writeStoredId(id) {
    try {
        if (typeof window === 'undefined') {
            return;
        }
        window.localStorage.setItem(STORAGE_KEY, id);
    }
    catch (_a) {
        // Quota or private mode
    }
}
async function computeFingerprintId() {
    var _a;
    const fingerprint = getBrowserFingerprint();
    if ((_a = window.crypto) === null || _a === void 0 ? void 0 : _a.subtle) {
        const msgUint8 = new TextEncoder().encode(String(fingerprint));
        const hashBuffer = await crypto.subtle.digest('SHA-1', msgUint8);
        // SHA-1 is 20 bytes (40 hex chars); UUID layout needs exactly 32 hex digits.
        const hashHex = Array.from(new Uint8Array(hashBuffer))
            .slice(0, 16)
            .map((b) => b.toString(16).padStart(2, '0'))
            .join('');
        return hashHex.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
    }
    return String(fingerprint);
}
let browserId = readStoredId();
const initPromise = (async () => {
    if (browserId !== null) {
        return;
    }
    const id = await computeFingerprintId();
    writeStoredId(id);
    browserId = id;
})();
/**
 * Stable browser-scoped identifier: reads `device-id` from localStorage when set,
 * otherwise derives from fingerprint, persists, then returns. Suspends until the
 * id is ready when storage was empty.
 */
export default function useBrowserId() {
    if (browserId === null) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw initPromise;
    }
    return browserId;
}
